module.exports = __webpack_public_path__ + "img/icon-more.1cc4f3f2.svg";